<template >
    <header class="header">
        <div class="container">
            <router-link :to="{name:'main'}"><img :src="images.logo" alt="Логотип" class="header__logo"></router-link>
            <button class="header__menu-button" :class="{open: menuOpen}" @click="toggleButton">
                <svg class="menu-closed" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.6665H35V9.99984H5V6.6665ZM5 18.3332H35V21.6665H5V18.3332ZM5 29.9998H35V33.3332H5V29.9998Z" fill="white"/>
                </svg>
                <svg class="menu-open" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.8333 18.4263L29.2596 10L31.6667 12.407L23.2404 20.8333L31.6667 29.2596L29.2596 31.6667L20.8333 23.2404L12.407 31.6667L10 29.2596L18.4263 20.8333L10 12.407L12.407 10L20.8333 18.4263Z" fill="white"/>
                </svg>
            </button>
            <div class="header__content">
                <div class="header__warning" title="Уведомления">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.3639 3.48644L21.8664 19.5405C21.9539 19.6884 22 19.8562 22 20.027C22 20.1978 21.9539 20.3656 21.8664 20.5135C21.7788 20.6614 21.6529 20.7842 21.5013 20.8696C21.3496 20.955 21.1776 21 21.0025 21H1.99751C1.82241 21 1.65039 20.955 1.49875 20.8696C1.34711 20.7842 1.22119 20.6614 1.13364 20.5135C1.04609 20.3656 0.999999 20.1978 1 20.027C1 19.8562 1.04609 19.6884 1.13364 19.5405L10.6361 3.48644C10.7237 3.33855 10.8496 3.21573 11.0013 3.13034C11.1529 3.04495 11.3249 3 11.5 3C11.6751 3 11.8471 3.04495 11.9987 3.13034C12.1504 3.21573 12.2763 3.33855 12.3639 3.48644ZM3.72523 19.054H19.2748L11.5 5.91888L3.72523 19.054ZM10.5025 16.1351H12.4975V18.0811H10.5025V16.1351ZM10.5025 9.3243H12.4975V14.1892H10.5025V9.3243Z" fill="#E09626"/>
                    </svg>
                </div>
                <div class="header__no-signal" title="Режим оффлайн">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5005 17.9399C13.2265 17.9399 13.8935 18.1949 14.4181 18.6192L12.5005 21L10.5829 18.6192C11.1253 18.1784 11.8025 17.9385 12.5005 17.9399ZM3.1545 1L21.1277 19.0323L19.69 20.4747L14.4232 15.1909C13.8031 14.9844 13.1539 14.8794 12.5005 14.8797C11.0486 14.8797 9.7146 15.3887 8.66734 16.2384L7.3903 14.6512C8.72637 13.5654 10.3723 12.9344 12.0897 12.8498L9.45025 10.2018C7.99849 10.6147 6.64534 11.3188 5.4727 12.2715L4.19363 10.6843C5.28949 9.79402 6.52045 9.08563 7.83971 8.58607L5.51744 6.25527C4.36149 6.80753 3.27452 7.49469 2.27908 8.30249L1 6.71633C1.93033 5.96149 2.93488 5.29744 4.00146 4.7354L1.7158 2.44336L3.1545 1ZM15.0424 10.0702L12.7201 7.74147L12.5005 7.73943C15.6474 7.73943 18.537 8.8421 20.8074 10.6843L19.5283 12.2715C18.2183 11.2067 16.6844 10.4541 15.0424 10.0702ZM12.5005 2.63921C16.8573 2.63921 20.8582 4.16622 24 6.71633L22.7219 8.30249C19.8306 5.95298 16.2213 4.67357 12.5005 4.6793C11.6078 4.6793 10.7314 4.7507 9.87728 4.89045L8.15388 3.15943C9.54582 2.81976 11.0028 2.63921 12.5005 2.63921Z" fill="#D04D4D"/>
                    </svg>
                </div>
                <router-link :to="{name:'profile'}" class="header__profile">
                    <img :src="images.profile" alt="">
                </router-link>
            </div>
        </div>
    </header>
</template>
<script setup lang="ts">
import headerLogo from "../assets/img/svg/headerLogo.svg"
import headerProfile from "../assets/img/svg/headerProfile.svg"

const props = defineProps({
    menuOpen: {
        type: Boolean,
        required: true,
        default: false
    }
})
const emit = defineEmits(['openMenu'])
const images = {
    logo: headerLogo,
    profile: headerProfile
}

function toggleButton() {
    emit('openMenu', open)
}
</script>